export default "__VITE_ASSET__c3e87c23__"